import React from 'react';
import Header from './Header';
import Main from './Main';
import Footer from './Footer';
import Copyright from './Copyright';

export default class App extends React.Component{
    render(){
        return(
            <div>
                <Header/>
                <Main/>
                <Footer/>
                <Copyright/>
            </div>
        );
    }
}